import { PropertiesTableProps } from '../../../../shared/types'
import { EditContainerProperties } from '../EditContainer/EditContainerDocs'

export const AnimatedContainerProperties: PropertiesTableProps = {
  ...EditContainerProperties,
}

export const AnimatedContainerEvents: PropertiesTableProps = {}
